/* eslint-disable react/no-unescaped-entities */
import PublicPageLayout, { Section } from "@/components/PublicPageLayout";

export default function Disclaimer() {
  return (
    <PublicPageLayout
      eyebrow="Important"
      title="Disclaimer"
      intro="Please read this carefully. The information you receive from this platform is for guidance only — not professional advice."
      testid="disclaimer-page"
    >
      <Section title="Not professional advice" testid="disclaimer-not-advice">
        <p>
          The AI Took My Job provides general information, AI-generated career suggestions and
          indicative government-support eligibility. We are <span className="font-medium">not</span>{" "}
          a registered career counsellor, financial planner, accountant, lawyer, registered
          migration agent, or medical professional.
        </p>
        <p>
          Nothing on this platform should be relied on as legal, financial, taxation, medical,
          migration or psychological advice. Always consult an appropriately qualified
          professional for decisions in those areas.
        </p>
      </Section>

      <Section title="AI limitations" testid="disclaimer-ai">
        <ul className="list-disc pl-6 space-y-2">
          <li>AI models can produce confident-sounding but incorrect information.</li>
          <li>Recommendations are based only on what you tell us in the assessment.</li>
          <li>
            We use a consensus across three models to reduce single-model error, but errors are
            still possible.
          </li>
          <li>Job markets, salary bands and program eligibility change — always verify before acting.</li>
        </ul>
      </Section>

      <Section title="Government support indications" testid="disclaimer-gov">
        <p>
          Our Australian government support screener is an indicator only. Final eligibility for
          any payment, course, grant or program is determined by the relevant authority
          (Services Australia, state training authorities, etc.). Apply through their official
          channels for a binding decision.
        </p>
      </Section>

      <Section title="Job matching" testid="disclaimer-jobs">
        <p>
          Job listings are sourced from third parties. We don't endorse any employer, don't
          guarantee a role is currently open, and don't have any influence on hiring outcomes.
        </p>
      </Section>

      <Section title="Outcomes" testid="disclaimer-outcomes">
        <p>
          Career change is influenced by many factors outside our control. We make no promise or
          guarantee about employment, income, course admission, payment approval or any specific
          outcome. Your results will depend on your effort, the market, and circumstances unique
          to you.
        </p>
      </Section>

      <Section title="External links" testid="disclaimer-links">
        <p>
          We link to external resources (government sites, training providers, job boards) for
          your convenience. We are not responsible for the content, accuracy or privacy practices
          of any external site.
        </p>
      </Section>

      <Section title="Mental health" testid="disclaimer-mental-health">
        <p>
          Losing work to AI is genuinely hard. This platform is <span className="font-medium">not</span>{" "}
          a substitute for mental-health support. If you are in distress, please contact
          Lifeline on <span className="font-medium">13 11 14</span> or Beyond Blue on{" "}
          <span className="font-medium">1300 22 4636</span>.
        </p>
      </Section>
    </PublicPageLayout>
  );
}
